import '../my_answer_tab/index_mWeb.css';
import { View, FlatListAutoHeight, RouteWrapper, EmptyData, LanguageBtn } from '../../../component';
import { s, vs } from '../../../utilities/scaling_utils';
import FlatList from 'flatlist-react';
import InsightInfo from '../../component/insight_info';
import FantasyYesNoRule from '../../component/fantasy_yes_no_rule';
import YesNoVideo from '../../component/yes_no_video';
import Button from '@mui/material/Button/Button';
import YNAnswerViewMWeb from '../../component/yn_answer_view/index_mWeb';
import NavigationHeader from '../../../component/navigation_header';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const MyAnswerTabMWeb = ({
  onCalledDeadline,
  answerList,
  onChange2x,
  onChangeMyAnswer,
  language,
  onPressInsight,
  insightInfoModal,
  insight,
  ruleModal,
  onPressDismissRule,
  yesNoVideoModal,
  onPressDismissYNVideo,
  onPressOpenRule,
  onPressOpenYNVideo,
  onChangeSave,
  onPressCloseInsight
}: any) => {
  const renderWhenEmpty = () => {
    return <EmptyData message={'No Question Found'} />;
  };
  const renderAnsItem = (item: any) => {
    const { sequence = 0 } = item;
    return (
      <YNAnswerViewMWeb
        key={item.id}
        item={item}
        qNo={sequence}
        editMode={true}
        onChange2x={() => onChange2x(sequence - 1)}
        onChangeMyAnswer={() => onChangeMyAnswer(sequence - 1)}
        language={language}
        onPressInsight={() => onPressInsight(sequence - 1)}
      />
    );
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onCalledDeadline} title={'Fantasy Yes/NO'} />
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '15px 10px 15px 10px',
            backgroundColor: '#192330'
          }}>
          <div
            style={{
              display: 'table',
              textAlign: 'right'
            }}>
            <LanguageBtn />
          </div>
          <Button
            style={{
              backgroundColor: 'transparent',
              color: '#fff'
            }}
            onClick={onPressOpenRule}
            className={'MyAnswerTab__button_mWeb'}>
            {'Points System'}
          </Button>
          <Button
            style={{
              backgroundColor: 'transparent',
              color: '#fff'
            }}
            onClick={onPressOpenYNVideo}
            className={'MyAnswerTab__button_mWeb '}>
            {'How to Play?'}
          </Button>
        </View>
        <View
          style={{
            flexGrow: 1,
            position: 'relative',
            marginTop: vs(10),
            marginLeft: s(20),
            marginRight: s(20)
          }}>
          <FlatListAutoHeight
            childStyle={{
              paddingBottom: vs(60)
            }}>
            <FlatList
              list={answerList}
              renderItem={renderAnsItem}
              renderWhenEmpty={renderWhenEmpty}
            />
          </FlatListAutoHeight>
          {answerList.length > 0 && (
            <View
              style={{
                position: 'absolute',
                zIndex: 10,
                right: 0,
                bottom: '7%',
                display: 'flex',
                alignItems: 'center',
                width: '100%'
              }}
              onPress={onChangeSave}>
              <button className="yesNo__answerTab__save__btn__mWeb">Save</button>
            </View>
          )}
        </View>
        <InsightInfo
          visible={insightInfoModal}
          onPressClose={onPressCloseInsight}
          insight={insight}
          language={language}
        />
        <FantasyYesNoRule
          visible={ruleModal}
          onPressDismiss={onPressDismissRule}
          language={language}
        />
        <YesNoVideo visible={yesNoVideoModal} onPressClose={onPressDismissYNVideo} />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default MyAnswerTabMWeb;
